import { Injectable } from '@angular/core';
import { PaginatedResponse } from '@fg-types/paginated-response';
import { ApiBase } from './api-base';
import { IFanRequestBase, ICreatorFanRequestBase } from '@fg-types/fan-request';

export class FanRequestBaseApi extends ApiBase {
  model = 'fanRequestBases';

  getOrgfanRequestBases(params?: {
    organizationIds?: string[];
    celebrityIds?: string[];
    lastKey?: string;
  }) {
    return this.http.get<PaginatedResponse<IFanRequestBase>>(`${this.modelBase}`, {
      params: this.setParams(params)
    });
  }

  //get all creator FanRequests
  getCreatorfanRequestBases(params?: {
    creatorId?: string;
    status?: string;
  }) {
    return this.http.get<PaginatedResponse<ICreatorFanRequestBase>>(`${this.modelBase}`,{
      params: this.setParams(params)
    })
  }

  deActivateFanRequestBase(id: string){
    return this.http.patch<ICreatorFanRequestBase>(`${this.modelBase}/${id}/deactivate?id=${id}`, {})
  }

  activateFanRequestBase(id: string){
    return this.http.patch<ICreatorFanRequestBase>(`${this.modelBase}/${id}/activate`, {})
  }

  patchFanRequestBase(id: string, body: IFanRequestBase) {
    return this.http.patch<IFanRequestBase>(`${this.modelBase}/${id}`, body);
  }

  createFanRequestBase(body: IFanRequestBase) {
    return this.http.post<IFanRequestBase>(`${this.modelBase}`, body);
  }

  //get all creator subscribers 
  getCreatorSubscribers(id : string,params:{active: boolean}){
    return this.http.get<any>(`${this.modelBase}/Creator/${id}/FanRequests`,{
      params: this.setParams(params)
    })
  }

  //get only subscribers related to FanRequest
  getFanRequestSubscribers(id : string, creatorid: string){
    return this.http.get<any>(`${this.modelBase}/${id}/Creator/${creatorid}/FanRequests`,{
      params: this.setParams({active: true})
    })
  }

  //get FanRequest by Id
  getFanRequestBase(id: string){
    return this.http.get<any>(`${this.modelBase}/${id}`)
  }
}
